import { MSG_TYPE_CONFIRM_DELETE_TASK, MSG_TYPE_DELETE_TASK_FAILURE, MSG_TYPE_DELETE_TASK_SUCCESS, MSG_TYPE_REQUEST_CLOSE_DELETE_TASK_MODAL, MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL } from '../constants/IFrameMessageTypes';
export const initialState = {
  failed: false,
  hasCampaignsWriteAccess: true,
  hasCampaignsReadAccess: true,
  loading: false,
  show: false,
  taskName: undefined,
  taskId: undefined,
  isRepeating: undefined
};
export default function taskDelete(state = initialState, action) {
  var _action$taskName, _action$taskId;
  switch (action.type) {
    case MSG_TYPE_DELETE_TASK_SUCCESS:
      return Object.assign({}, state, {
        failed: false,
        loading: false,
        show: false,
        taskName: undefined,
        taskId: undefined,
        isRepeating: undefined
      });
    case MSG_TYPE_DELETE_TASK_FAILURE:
      return Object.assign({}, state, {
        failed: true,
        loading: false
      });
    case MSG_TYPE_CONFIRM_DELETE_TASK:
      return Object.assign({}, state, {
        failed: false,
        loading: true
      });
    case MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL:
      return Object.assign({}, state, {
        show: true,
        taskName: (_action$taskName = action.taskName) !== null && _action$taskName !== void 0 ? _action$taskName : state.taskName,
        taskId: (_action$taskId = action.taskId) !== null && _action$taskId !== void 0 ? _action$taskId : state.taskId,
        isRepeating: action.isRepeating
      });
    case MSG_TYPE_REQUEST_CLOSE_DELETE_TASK_MODAL:
      return Object.assign({}, state, {
        show: false,
        isRepeating: undefined
      });
    default:
      return state;
  }
}